import { initTheme } from 'src/lib/util/theme-utils'
import { appPreferences } from 'src/boot/preferences'

const Boot = async () => {
  const tenant = await appPreferences.getTenant()

  if (!tenant) {
    return
  }

  initTheme(tenant)
}

export default Boot
